import React from 'react';
import PropTypes from 'prop-types';
import { TEXT_LABELS } from '../../constants/TextLabelConstants';
import './AppFooter.css';

/** Figma 18055:23256 — centered copyright footer (transparent) */
export default function AppFooter({ text = TEXT_LABELS.COPY_RIGHT_TEXT_LABEL, className = '' }) {
  return (
    <footer className={`rap-app-footer${className ? ` ${className}` : ''}`}>
      <p className="rap-app-footer__text">{text}</p>
    </footer>
  );
}

AppFooter.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
};
